import { render, staticRenderFns } from "./ItemTerms.vue?vue&type=template&id=4e67bfca&scoped=true"
import script from "./ItemTerms.vue?vue&type=script&lang=js"
export * from "./ItemTerms.vue?vue&type=script&lang=js"
import style0 from "./ItemTerms.vue?vue&type=style&index=0&id=4e67bfca&prod&lang=css"
import style1 from "./ItemTerms.vue?vue&type=style&index=1&id=4e67bfca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e67bfca",
  null
  
)

export default component.exports